
export default function FounderTestimonials() {
  const testimonials = [
    {
      quote: "Finally — an evaluation that isn't just someone's opinion.",
      author: "Founder, Productivity App",
      role: "Early-Stage",
      content: "I didn't want random feedback or beta tester opinions. CrowdRounds showed me exactly where my app's strengths and weaknesses were using a structured model. It helped me skip months of guessing.",
      rating: 5
    },
    {
      quote: "The intelligence layers helped me reposition my feature roadmap.",
      author: "CEO, FinTech Startup",
      role: "Series A",
      content: "The competitive and category benchmarks were extremely useful. The insights helped me prioritize what actually moves growth, not what I thought mattered.",
      rating: 5
    },
    {
      quote: "This is the only evaluation I've seen that feels investor-grade.",
      author: "Serial Founder, HealthTech",
      role: "Pre-Seed",
      content: "Clear, objective scoring. Strategic next steps. Investor readiness signals. If you're preparing to scale or raise, this is the kind of clarity you want before conversations.",
      rating: 5
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-slate-50 to-teal-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            What Founders Are Saying
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Real perspectives from founders who chose structured intelligence over guesswork
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border-2 border-slate-100 hover:border-teal-200"
            >
              {/* Rating Stars */}
              <div className="flex gap-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-xl w-5 h-5 flex items-center justify-center"></i>
                ))}
              </div>

              {/* Quote */}
              <blockquote className="mb-6">
                <p className="text-xl font-semibold text-slate-900 mb-4">
                  "{testimonial.quote}"
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {testimonial.content}
                </p>
              </blockquote>

              {/* Author */}
              <div className="pt-6 border-t-2 border-slate-100">
                <div className="font-semibold text-slate-900">{testimonial.author}</div>
                <div className="text-sm text-teal-600">{testimonial.role}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Badge */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 bg-white px-8 py-4 rounded-full shadow-md border-2 border-teal-100">
            <i className="ri-shield-check-fill text-teal-600 text-2xl w-6 h-6 flex items-center justify-center"></i>
            <span className="text-slate-700 font-medium">
              Trusted by founders across productivity, fintech, healthtech, and more
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
